export default "__VITE_ASSET__BU0GllTF__"